export function getPaymentsForPayoutV4(send) {
  return (payoutId, query, ...args) =>
    send(
      {
        path: '/v4/paymentaudit/payouts/{payoutId}',
        pathParameters: { payoutId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
